var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.241 7.813V.715A.73.73 0 0 0 8.526 0a.698.698 0 0 0-.715.715v7.098c0 .97 1.43.97 1.43 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.33 1.43C3.011 2.4.662 5.515.662 8.987c0 4.29 3.524 7.813 7.864 7.813 4.29 0 7.813-3.524 7.813-7.813 0-3.472-2.298-6.587-5.617-7.557-.92-.256-1.328 1.123-.409 1.378a6.465 6.465 0 0 1 4.596 6.18 6.385 6.385 0 0 1-6.383 6.382c-3.523 0-6.434-2.86-6.434-6.383 0-2.86 1.89-5.361 4.596-6.179.919-.255.51-1.634-.358-1.378Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.fa213e6409e01cc0d446744a56aca1ad.svg";
export { ForwardRef as ReactComponent };